export enum DocType {
  USER_GUIDE = "USER_GUIDE",
  INST_GUIDE = "INST_GUIDE",
}
